import CommonList from "../../../common/list";
import {columns} from "./columns/columns";
import React, {useEffect, useState} from "react";
import TableTitle from "../../../common/list/components/TableTitle";
import {useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {getAllCustomers} from "../../../api/customer";
import EditParent from "./editParent";
import EditParentWS from "../weighing-station/editParent";

const Customer = () => {

    const [searchParams] = useSearchParams();
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const [dataSource, setDatSource] = useState()
    const [total, setTotal] = useState()
    const [visible, setVisible] = useState()
    const [id, setId] = useState()
    const [name, setName] = useState()
    const [visibleWeighingStation, setVisibleWeighingStation] = useState()
    const [idWeighingStation, setIdWeighingStation] = useState()
    const [nameWeighingStation, setNameWeighingStation] = useState()

    const getWeighingStations = (data) => {

        if (data?.length > 0) {
            return (
                data?.map((item,index) => {
                    if (index === data?.length - 1){
                        return (
                            <span style={{ color : "#1890FF" }} onClick={()=>{
                                setVisibleWeighingStation(true)
                                setIdWeighingStation(item.id)
                                setNameWeighingStation(item.weighingStationName)
                            }} >
                                {item.weighingStationName}
                            </span>
                        )
                    }else{
                        return (
                            <span style={{ color : "#1890FF" }} onClick={()=>{
                                setVisibleWeighingStation(true)
                                setIdWeighingStation(item.id)
                                setNameWeighingStation(item.weighingStationName)
                            }}>
                               {item.weighingStationName},{ " " }
                            </span>
                        )
                    }
                })
            )
        }

        return null;

    }

    const getPhoneNumber = (data) =>{
        let subString = "\\+"
        if (data !== undefined && data !== ""){
            if (data.match(new RegExp(subString)) !== null ){
                return data.replace(/(\+\d{2})(\d{3})(\d{3})(\d{3})/, '($1) $2 $3 $4');
            }else{
                return data.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
            }
        }

        return ""
    }
    const mapDatasource = (data) => {
        if (!data) {
            return [];
        }
        return data?.map((item) => {
            return {
                ...item,
                weighingStations: getWeighingStations(item.list),
                phoneNumber : getPhoneNumber(item.phoneNumber)
            };
        });
    }
    const loadData = async (page, pageSize,search) => {
        getAllCustomers(page, pageSize, search).then(r => {
            setDatSource(mapDatasource(r.data))
            setTotal(r.totalPage)
        })
            .catch(() => {
            })
    }

    useEffect(() => {
        loadData(searchParams.get("page"),
            searchParams.get("pageSize"),
            searchParams.get("search")).then(r => r)
    }, [searchParams, reloadData])

    return (
        <div className={"h-full"}>
            <TableTitle
                title={"Danh sách khách hàng"}
            />
            {
                dataSource && <CommonList
                    columns={columns}
                    totalCount={total}
                    dataSource={dataSource}
                    onRow={(record) => {
                        return {
                            onClick: () => {
                                setVisible(true)
                                setId(record.id)
                                setName(record.customerName)
                            }
                        }
                    }}
                />
            }
            <EditParent id={id}
                        visible={visible}
                        onCancel={() => {
                            setVisible(false)
                            setId(undefined)
                            setName(undefined)
                        }}
                        name={name}/>
            <EditParentWS id={idWeighingStation}
                        name={nameWeighingStation}
                        visible={visibleWeighingStation}
                        onCancel={() => {
                            setIdWeighingStation(undefined)
                            setNameWeighingStation(undefined)
                            setVisibleWeighingStation(undefined)
                        }}/>
        </div>
    )
}
export default Customer
